import { useContext } from 'react';
import { IntlContext } from 'react-intl';

import type { MessageId, MessageValues } from './ids';
import { getIntl, renderCatalogMessage } from './internal/intl';

type MessageProps<K extends MessageId> = { id: K } & ([MessageValues<K>] extends [never]
  ? { values?: undefined }
  : { values: MessageValues<K> });

export function Message<K extends MessageId>({ id, values }: MessageProps<K>) {
  // Falls back to the registered intl so a test with the test catalog installed needs no provider.
  const intl = useContext(IntlContext) ?? getIntl();
  return renderCatalogMessage(intl, id, values);
}
